// extracted by mini-css-extract-plugin
export var carrierIcon = "_v2-0";
export var carrierLogo = "_v2-1";
export var detailsSection = "_v2-2";